
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.523.996L.994 22.317M11.781 11.351L2.64 7.014a1.68 1.68 0 01-.785-2.092A1.681 1.681 0 013.848 3.91l9.964 2.911M14.229 20.25h2.292M9.75 16.5v-3c0-.823.677-1.5 1.5-1.5h10.5c.823 0 1.5.677 1.5 1.5v6.375","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12.75 12l1.259-5.544A1.505 1.505 0 0115.48 5.25h3.27c.823 0 1.5.677 1.5 1.5V12","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"10.875","cy":"19.875","r":"3.375","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10.875 20.25a.376.376 0 01-.375-.375M11.25 19.875a.376.376 0 01-.375.375M10.875 19.5c.206 0 .375.169.375.375M10.5 19.875c0-.206.169-.375.375-.375","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"19.875","cy":"19.875","r":"3.375","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M19.875 20.25a.376.376 0 01-.375-.375M20.25 19.875a.376.376 0 01-.375.375M19.875 19.5c.206 0 .375.169.375.375M19.5 19.875c0-.206.169-.375.375-.375","fill":"none","stroke":"#000","stroke-width":"1.5"}})])
          )
        }
      }
    